import { BaseEntity } from '../entities/BaseEntities';
import CustomStore from "devextreme/data/custom_store";
import { BaseEndpointCRUD } from '../endpoint/BaseEndpointCRUD';
import { BaseDataStoreAbstract } from './BaseDataStoreAbstract';
import { DataLoadOptions } from './DataLoadOptions';


export class BaseDataStoreCRUD<TEntity extends BaseEntity> extends BaseDataStoreAbstract
{
    constructor(private endpoint: BaseEndpointCRUD<TEntity>)
    {
        //Call base
        super();

        this.m_store = new CustomStore({
            key: "EntryID",
            loadMode: "processed",
            load: (loadOptions) => this.ImplementLoad(loadOptions),
            byKey: (Value) => this.ImplementByKey(Value)
        });
    }

    //Perform the actual load
    private ImplementLoad(loadOptions): Promise<any>
    {
        //Prepare options object
        var options = new DataLoadOptions(loadOptions);

        //Return data from the service
        return this.ShapeResponse(this.endpoint.GetList(options));
    }

    //Get data by key
    private ImplementByKey(Value: any): Promise<any>
    {
        return this.ShapeResponse(this.endpoint.Get(Value));
    }
}